import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';
import type { History } from 'history';

import accounts from './Accounts/reducers';
import approvals from './Approvals/reducers';
import autofill from './Autofill/reducers';
import clients from './Clients/reducers';
import clusterAssignModal from './ClusterAssignModal/reducers';
import clusters from './Clusters/reducers';
import company from './Company/reducers';
import dataSources from './DataSources/reducers';
import dimensions from './Dimensions/reducers';
import general from './General/reducers';
import intacct from './Intacct/reducers';
import items from './Items/reducers';
import local from './Local/reducers';
import projects from './Projects/reducers';
import saml from './Saml/reducers';
import tasks from './Tasks/reducers';
import team from './Team/reducers';
import timesheet from './Timesheet/reducers';
import timesheetEntries from './TimesheetEntries/reducers';
import timesheetRows from './TimesheetRows/reducers';
import timesheets from './Timesheets/reducers';
import timeTypes from './TimeTypes/reducers';
import user from './User/reducers';
import userNotificationSettings from './UserNotificationSettings/reducers';
import userSettings from './UserSettings/reducers';

const createRootReducer = (history: History<unknown>) =>
  combineReducers({
    accounts,
    approvals,
    autofill,
    clients,
    clusterAssignModal,
    clusters,
    company,
    dataSources,
    dimensions,
    general,
    intacct,
    items,
    local,
    projects,
    router: connectRouter(history),
    saml,
    tasks,
    team,
    timesheet,
    timesheetEntries,
    timesheetRows,
    timesheets,
    timeTypes,
    user,
    userNotificationSettings,
    userSettings,
  });

export default createRootReducer;
